import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setTelemetryContext } from '../lib/telemetry';

/** Keeps telemetry pathname in sync with the active route. */
export default function TelemetryRouteSync() {
  const location = useLocation();

  useEffect(() => {
    setTelemetryContext({ pathname: location.pathname });
  }, [location.pathname]);

  return null;
}
